import React from 'react'

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear()

    return (
        <footer className="footer py-4" id="footer">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-4 text-lg-start">Copyright &copy; The House of Afros, Capes and Curls {currentYear}</div>
                    <div className="col-lg-4 my-3 my-lg-0">
                        <a
                            className="btn btn-dark btn-social mx-2"
                            href="https://twitter.com/_HOACC"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Follow us on Twitter"
                        >
                            <i className="fab fa-twitter" aria-hidden="true"></i>
                        </a>
                        <a
                            className="btn btn-dark btn-social mx-2"
                            href="https://www.facebook.com/afroscapescurls/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Follow us on Facebook"
                        >
                            <i className="fab fa-facebook-f" aria-hidden="true"></i>
                        </a>
                        <a
                            className="btn btn-dark btn-social mx-2"
                            href="https://www.instagram.com/houseafrocon/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Follow us on Instagram"
                        >
                            <i className="fab fa-instagram" aria-hidden="true"></i>
                        </a>
                        <a
                            className="btn btn-dark btn-social mx-2"
                            href="https://discord.gg/EhWcvQWBu6"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Join our Discord server"
                        >
                            <i className="fab fa-discord" aria-hidden="true"></i>
                        </a>
                        <a
                            className="btn btn-dark btn-social mx-2"
                            href="https://www.twitch.tv/thehouseofafroscapescurls"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Watch us on Twitch"
                        >
                            <i className="fab fa-twitch" aria-hidden="true"></i>
                        </a>
                    </div>
                    <div className="col-lg-4 text-lg-end">
                        <a className="text-light" href="mailto:info@afroscapescurls.org">
                            info@afroscapescurls.org
                        </a>
                    </div>
                </div>
                <div className="row">
                    <div className="col text-start">The House of Afros, Capes and Curls is a 501(c)(3) Organization</div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
